import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SuperStarForDropdown as SUPER_STAR_DROPDOWN } from "src/components/api/register_super_star/registerSuperStar";
import { PromotionalPartnerForDropdown as PROMOTIONAL_PARTNER_DROPDOWN } from "src/components/api/register_promotional_partner/registerPromotionalPartner";
import { ToastError } from '../uiElements/toast';
import { LOGOUT } from "src/components/helper/constants";
import AdminPageSessionClose from "src/components/util/adminPageSessionClose";

type RequestProps = {
    PromotionalPartnerMasterID: number;
    PromotionalPartner: string;
    SuperStarMasterID: number;
    SuperStarName: string;
    ImagePath:string;
};

const UseHeader = () => {

    const [superStarList, setSuperStarList] = React.useState([]);
    const [promotionalPartnerList, setPromotionalPartnerList] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);

    const defaultValues = {
        SuperStarMasterID: 0,
        PromotionalPartnerMasterID: 0,
        PromotionalPartner: "",
        SuperStarName: "",
        ImagePath:"",
    };

    const validationSchema = Yup.object().shape({
        //TeamName: Yup.string().required("Team name is required"),
    });

    const formContext = useForm<RequestProps>({
        defaultValues,
        resolver: yupResolver(validationSchema) as any,
    });
    const { reset, setValue } = formContext;

    const resetForm = () => {
        reset({
            SuperStarName: "",            
        });
        setIsUpdate(false);
    };

    useEffect(() => {
        selectSuperStar();
        selectPromotionalPartner();
        AdminPageSessionClose();
    }, []);

    const selectSuperStar = async () => {
        setSuperStarList([]);
        const response = await SUPER_STAR_DROPDOWN();
        console.log("Super star list response", response);
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }
        var data = JSON.parse(response?.data!);
        setSuperStarList(data);
        reset();
    };
    
    const selectPromotionalPartner = async () => {
        setPromotionalPartnerList([]);
        const response = await PROMOTIONAL_PARTNER_DROPDOWN();
        console.log("Promotional partner list response", response);
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }
        var data = JSON.parse(response?.data!);
        setPromotionalPartnerList(data);
        reset();
    };

    return {
        superStarList,
        promotionalPartnerList,
    }
}

export default UseHeader;
